namespace RioERP.Masters {
    export interface TaxCategoryRow {
        Id?: number;
        Name?: string;
        IsActive?: boolean;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace TaxCategoryRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Masters.TaxCategory';
        export const lookupKey = 'Masters.TaxCategory';

        export function getLookup(): Q.Lookup<TaxCategoryRow> {
            return Q.getLookup<TaxCategoryRow>('Masters.TaxCategory');
        }
        export const deletePermission = 'Masters:MastersManagement:Modify';
        export const insertPermission = 'Masters:MastersManagement:Modify';
        export const readPermission = 'Masters:MastersManagement:View';
        export const updatePermission = 'Masters:MastersManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            IsActive = "IsActive",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
